import { useState, useMemo } from "react";
import { useFetchNotas } from "../useGetNotes"; 

export const useGetNotesBySection = (token, idSeccion, fecha, idDocumento) => {
  const [refresh, setRefresh] = useState(false);
  const { notas, loadingNote } = useFetchNotas(token, fecha, idSeccion, refresh, idDocumento);

  const notes = useMemo(() => {
    if (!notas || !Array.isArray(notas)) return [];
    
    return notas.map(nota => ({
      ...nota,
      id_nota: nota.id_sintesis ? Number(nota.id_sintesis) : null
    }));
  }, [notas]);

  return { 
    notes, 
    loadingNotes: loadingNote, 
    refresh: () => setRefresh(prev => !prev) 
  };
};